/* eslint-disable jsx-a11y/anchor-has-content */
import i18nInstance from 'i18n/i18nInstance'
import { BogoTermsLink } from '@mc/bogo'
import type { Section } from '@mc/faq'
import { Trans } from '@mc/i18n'
import { paths } from '@mc/paths'

const t = i18nInstance.getFixedT(null, '@mc/next')

export const getBogoSection: () => Section = () => ({
  title: t('faq.bogo.title'),
  questions: [
    {
      title: t('faq.bogo.question1'),
      uuid: 'faq.bogo.question1.string',
      answer: (
        <Trans i18nKey='faq.bogo.answer1' ns='@mc/next'>
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      title: t('faq.bogo.question2'),
      uuid: 'faq.bogo.question2.string',
      answer: (
        <Trans i18nKey='faq.bogo.answer2' ns='@mc/next'>
          <p className='mc-opacity--hinted'>
            <a className='mc-text--link' href={paths.supportBogo} />
          </p>
        </Trans>
      ),
    },
    {
      title: t('faq.bogo.question3'),
      uuid: 'faq.bogo.question3.string',
      answer: (
        <Trans i18nKey='faq.bogo.answer3' ns='@mc/next'>
          <p className='mc-opacity--hinted'>
            <a className='mc-text--link' href={paths.supportBogo} />
          </p>
        </Trans>
      ),
    },
    {
      title: t('faq.bogo.question4'),
      uuid: 'faq.bogo.question4.string',
      answer: (
        <Trans i18nKey='faq.bogo.answer4' ns='@mc/next'>
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      title: t('faq.bogo.question5'),
      uuid: 'faq.bogo.question5.string',
      answer: (
        <Trans i18nKey='faq.bogo.answer5' ns='@mc/next'>
          <p className='mc-opacity--hinted'>
            <BogoTermsLink />
          </p>
        </Trans>
      ),
    },
  ],
})
